<template>

    <div class="control">
        <div class="status">
            <el-button plain type="primary" @click="connectDevice" v-if="!connected" size="small">连接设备</el-button>
            <el-button plain type="danger" @click="disconnectDevice" v-if="connected" size="small">断开连接</el-button>
            
        </div>

        <div >
            <el-form-item label="I2C地址">
                <el-radio-group v-model="currentI2cAddr">
                        <el-radio-button v-for="addr in i2cAddr" :key="addr" :value="addr">
                            {{ '0x'+addr.toString(16) }}
                        </el-radio-button>
                </el-radio-group> 
                <el-button plain type="primary" size="small" @click="scanI2C">扫描设备</el-button>
            </el-form-item>
            <el-form-item label="寄存器地址">
                <el-input
                    v-model="regAddr"
                    style="width: 80px"
                    placeholder="HEX"
                    clearable
                />
                <el-button plain @click="readReg" >读取</el-button>
                <el-checkbox-group v-model="regValL" @change="valLChange">
                    <el-checkbox-button v-for="bit in regL" :key="bit" :value="bit">
                        {{ bit }}
                    </el-checkbox-button>
                </el-checkbox-group>
                <el-input
                    v-model="regValHex"
                    style="width: 140px"
                    placeholder=""
                    clearable
                ><template #prepend>HEX</template>
            </el-input>
                <el-input
                    v-model="regValDec"
                    style="width: 140px"
                    placeholder=""
                    type="number"
                    clearable
                >
                <template #prepend>DEC</template>
            </el-input>
                <el-button plain @click="sendCommand" >写入</el-button>
            </el-form-item>
            <el-form-item label="读取寄存器">
              <el-input
                v-model="regDefine"
                style="width: 100%"
                :rows="10"
                type="textarea"
                placeholder="Please input"
                />
                <el-button plain @click="readRegArray" >读取</el-button>
            </el-form-item>
            <el-table :data="regValues" style="width: 100%">
            <el-table-column prop="reg" label="地址" width="80" />
            <el-table-column prop="hex" label="Hex" width="100"/>
            <el-table-column prop="name" label="名称" width="80" />
            <el-table-column prop="val" label="值" width="100"/>
            <el-table-column prop="unit" label="单位" width="80" />            
            <el-table-column prop="val" label="BITS" width="800">
              <template #default="scope">
                <div v-if="scope.row.bits">           
                  <el-checkbox-group v-for="index of scope.row.bytes" :key="index" >
                      <el-checkbox-button v-for="bit of valToBit((scope.row.val >>((index-1)*8)) & 0xFF,1)" :key="bit" :value="bit">
                          {{ bit }}
                      </el-checkbox-button>
                  </el-checkbox-group>
                </div>
            </template>
            </el-table-column>
           
            <el-table-column prop="desc" label="说明" />
          </el-table>
            <!-- <div class="command-section">
                
                <input type="text" v-model="command" placeholder="输入命令（十六进制）">
                <button @click="sendCommand" >发送命令</button>
            </div> -->
        </div>

    </div>
   

</template>
<script setup>
  import { ref, reactive, computed, onMounted,watch } from 'vue'
  import { arrayBuffer2hex,hexToArrayBuffer} from '@/utils/hex.ts'
//   import { ElMessage } from 'element-plus'
  
const connected = ref(false)
const device = ref(null)

const serviceUUID = '0000ffe0-0000-1000-8000-00805f9b34fb' // 默认心率服务
const char1UUID = '0000ffe1-0000-1000-8000-00805f9b34fb' 
// 新增状态变量
const char2UUID = '0000ffe2-0000-1000-8000-00805f9b34fb' 

const currentI2cAddr = ref()
const i2cAddr = ref([])
const regAddr = ref()
const regValHex = ref()
const regValDec = ref(0)

const regL =  [7,6,5,4,3,2,1,0]
const regH =  [7,6,5,4,3,2,1,0]
const regValL = ref([])
const regValH = ref()
const regValues = reactive([])
const regDefine = ref('')

let server = null
let service = null 
let chart1 = null
let chart2 = null

const command = ref('')
// const logs = reactive([])

const deviceInfo = reactive({
  name: '',
  id: ''
})
function valToBit(val,bytes){
  let bits = []
  if(isLittleEndian){
    for(let i=bytes*8-1;i>=0;i--){
      bits.push(val>>i & 0x01)
    }
  }else{
    for(let i=0;i<bytes*8;i++){
      bits.push(val>>i & 0x01)
    }
  }
  console.log('bits',bits)
  return bits
}
function intToLittleEndian(value) {
    return (value & 0xFF) << 24 | (value & 0xFF00) << 8 | (value & 0xFF0000) >> 8 | (value & 0xFF000000) >>> 24;
}
const isLittleEndian = true
const getValue = (view,type,littleEndian) =>{
  switch(type){
    case 'u8':      
      return view.getUint8(0,littleEndian)      
    case 'u16':
      return view.getUint16(0,littleEndian)
    case 'u32':
      return view.getUint32(0,littleEndian)
    case 'i8':
      return view.getInt8(0,littleEndian)
    case 'i16':
      return view.getInt16(0,littleEndian)
    case 'i32':
      return view.getInt32(0,littleEndian)   
  }
  return 0;
}
const readRegArray = async ()=>{
  
  let json = JSON.parse(regDefine.value)
  regValues.length = 0
  for(let regDef of json){
    let reg =  regDef['reg'].includes('x')?parseInt(regDef['reg'],16):parseInt(regDef['reg'])
    let type = regDef['type']
    let bytes = parseInt(type.substr(1))/8
    let dat = await readReg(reg.toString(16).padStart(2, "0"),bytes)
    const view = new DataView(dat.buffer);
    regDef['bytes'] = bytes
    regDef['val'] = getValue(view,type,isLittleEndian)
    regDef['hex'] = arrayBuffer2hex(dat.buffer.slice(0,bytes))
    if(regDef['bits'] ){
        let bitStr = ''
        for(let bdef of regDef['bits']){
          let mask = 0;
          for(let b=0;b<bdef['nbits'];b++){
            mask |= 1<< (bdef['bit']+b)
          }
          console.log('mask',mask)
          let val = ((isLittleEndian?intToLittleEndian(regDef['val']):regDef['val']) & mask) >> bdef['bit']
          bitStr+= bdef['name']+":"+val+';'
        }
        regDef['bitsVal'] = bitStr
    }

    console.log(reg,dat,view)
    regValues.push(regDef)
  }
  console.log('regs',regValues)

  // let arr = regRegArray.value.split(',')
  // for(let r of arr){
  //   await readReg(r,2)
  // }
}
const valLChange = (val)=>{
    let res = 0
    for(let v of val){
        res+= 1<< v
    }
    //regValHex.value = res.toString(16).padStart(2, "0")
    regValDec.value = res
    console.log('valL',val,res,regValL.value)
}

const regLValue = computed(() => {
    console.log('cc',regValL.value)
    let res = 0
    for(let v in regValL.value){
        res+= 1<< v
    }
    return res
})

watch(regValHex,(newVal,oldVal)=>{
    let val = parseInt(newVal,16)
    regValDec.value = val
})

watch(regValDec,(newVal,oldVal)=>{
    let val = parseInt(newVal)
    regValL.value.length = 0
    if(newVal){
        regValHex.value = val.toString(16).padStart(2, "0")
        for(let i=0;i<8;i++){           
            if(val>>i & 0x01){
                
                regValL.value.push(i)
            }
        }
        console.log('vv',regValL)
    }    
})
// 计算属性
//const connectionStatus = computed(() => connected.value ? '已连接' : '未连接')
//const canSend = computed(() => command.value.trim() !== '')

const scanI2C = async ()=>{
    // 将命令转换为ArrayBuffer
    const data = hexToArrayBuffer('200101')    
    await chart1.writeValue(data)
    const val = await chart1.readValue()
    //20 01 6A 00 00 00 00 D4 33 00 20 14 00 00 00 00 00
    const arr = new Uint8Array(val.buffer)
    const len = arr[1]
    for(let i = 0;i<len;i++){
        i2cAddr.value.push(arr[i+2])
    }
    //const hexVal = arrayBuffer2hex(val.buffer)

}

const readReg = async (reg,len)=>{
    
    const dat = '2103'+parseInt(currentI2cAddr.value).toString(16).padStart(2, "0")+reg+'0'+len
    console.log('reg',dat)
    //将命令转换为ArrayBuffer
    const data = hexToArrayBuffer(dat)    
    await chart1.writeValue(data)
    const val = await chart1.readValue()
    //20 01 6A 00 00 00 00 D4 33 00 20 14 00 00 00 00 00
    const arr = new Uint8Array(val.buffer)
    return arr.slice(5,5+len)
    //regValDec.value = arr[5]
    // const len = arr[1]
    // for(let i = 0;i<len;i++){
    //     i2cAddr.value.push(arr[i+2])
    // }
    //const hexVal = arrayBuffer2hex(val.buffer)
    //console.log('readReg',reg,len,hexVal)

}

// 日志记录
const addLog = (message) => {
    console.log(message)
}

// 连接设备
const connectDevice = async () => {
  try {
    device.value = await navigator.bluetooth.requestDevice({
      acceptAllDevices: false,    
      optionalServices: [serviceUUID],
      filters: [ 
        { namePrefix: 'BLE' } 
      ]
    })
    
    deviceInfo.name = device.value.name
    deviceInfo.id = device.value.id
    
    device.value.addEventListener('gattserverdisconnected', disconnectHandler)
    
    server = await device.value.gatt.connect()
    connected.value = true
    

    service = await server.getPrimaryService(serviceUUID)
    chart1 = await service.getCharacteristic(char1UUID)
    chart2 = await service.getCharacteristic(char2UUID)
    addLog(`已连接至设备: ${device.value.name}`)
  } catch (error) {
    addLog(`连接失败: ${error}`)
  }
}

// 断开连接处理
const disconnectHandler = () => {
  connected.value = false
  deviceInfo.name = ''
  deviceInfo.id = ''
  addLog('设备已断开连接')
}

// 主动断开连接
const disconnectDevice = () => {
  if (device.value?.gatt.connected) {
    device.value.gatt.disconnect()
  }
  connected.value = false
}

// 发送命令
const sendCommand = async (hexStr) => {
  try {   
    // 将命令转换为ArrayBuffer
    const data = hexToArrayBuffer(hexStr)    
    await chart1.writeValue(data)
    const val = await chart1.readValue()
    const hexVal = arrayBuffer2hex(val.buffer)
  
    addLog(`命令已发送: ${command.value} 结果：${hexVal}`)
    command.value = ''
  } catch (error) {
    addLog(`发送失败: ${error}`)
  }
}


onMounted(()=>{
    
})
</script>
<style scoped>
.device-info{
    width: 90%;
}

.control {
  width: 95%;
  margin: 2rem auto;
  padding: 20px;
  background: #f5f5f5;
  border-radius: 10px;
  text-align: center;
}


</style>